import AxiosInstance from "../instance";
import {emptyFn, returnValidResponse} from "../utils";

interface ITextToSpeechData {
    text: string;
    language_code: string;
    gender: string;
    name: string;
    speaking_rate: number;
    pitch: number;
};

const getTextToSpeechResult = async (data: ITextToSpeechData) => {
    const response = await AxiosInstance.getInstance().post("/text-to-speech", data, {
        responseType: "blob"
    });

    return response;
};

const getTextToSpeechConfig = async () => {
    const response = await AxiosInstance.getInstance().get("/text-to-speech/config").catch(emptyFn);
    return returnValidResponse(response);
};

export {getTextToSpeechConfig, getTextToSpeechResult};


// WEBPACK FOOTER //
// ./src/api/models/TextToSpeech.ts